import { render, staticRenderFns } from "./TextCenter.vue?vue&type=template&id=3e7e79d0&scoped=true"
import script from "./TextCenter.vue?vue&type=script&lang=js"
export * from "./TextCenter.vue?vue&type=script&lang=js"
import style0 from "./TextCenter.vue?vue&type=style&index=0&id=3e7e79d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e79d0",
  null
  
)

export default component.exports